/**
 * Text Select Fields
 * Fetches suggested options from AJAX endpoint based on user input
 */
(function(factory) {
    if ( typeof define === "function" && define.amd ) {
        define(['jquery'], factory);
    } else {
        factory(jQuery);
    }
})(function($) {

    $.fn.textSelect = function(options) {
        var opts = $.extend( {}, $.fn.textSelect.defaults, options );

        function loadSelectData(url, callback) {
            $.get(url, function(data) {
                callback(data);
            });
        }

        $(this).each(function(i, obj) {
            var $this = $(obj);
            var $input = $('input[type="text"]', $this);
            var url = $this.data('select-url');
            var timeoutID = null;

            $this.addClass('text-select');

            var $resetButton = $('<div class="reset-button"></div>').appendTo($this);
            var $dataList = $('<ul class="data-list"></ul>').appendTo($this);


            $input.on('input', function(e) {
                    if (timeoutID) {
                        clearTimeout(timeoutID);
                    }

                    if ($input.val().length > 1) {
                        timeoutID = setTimeout(function() {
                            loadSelectData(url+'?q='+$input.val(), function(data) {
                                var hasData = false;

                                $dataList.empty();

                                for (i in data) {
                                    hasData = true;
                                    if (i == opts.maxResults) break;

                                    $dataList.append('<li><a href="#" data-select-key="'+i+'" data-select-value="'+data[i]+'">'+data[i]+'</a></li>');
                                }

                                if (hasData) {
                                    $dataList.fadeIn(150);
                                } else {
                                    $dataList.fadeOut(100);
                                }

                                $('a', $dataList).on('click', function(e) {
                                    e.preventDefault();

                                    $input.val($(this).html());
                                    $dataList.fadeOut();
                                });
                            });
                        }, 500);
                    }
            });
        });

        return this;
    };

    $.fn.textSelect.defaults = {
        maxResults: 50,
    };

});
